import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Settings } from 'luxon';
import { BrowserRouter, Route, Routes } from 'react-router';
import { i18n, MobileProvider, NotFound, theme, Toaster } from '@shared';
import { ChakraProvider } from '@chakra-ui/react';
import { ErrorBoundary, toaster, parseErrorToString } from '@shared';
import './index.css';
import { Survey } from '@survey';

Settings.defaultZone = import.meta.env.VITE_DEFAULT_TIMEZONE as string;

const staleTime = 2 * 60 * 1000; // 2 minutes
const root = createRoot(document.getElementById('root') as HTMLElement);

const mutationCache = new MutationCache({
	onError: error => {
		toaster.create({ type: 'error', title: parseErrorToString(error) });
	},
});

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: staleTime,
			retry: 0,
		},
	},
	mutationCache: mutationCache,
});

root.render(
	<I18nextProvider i18n={i18n}>
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<ChakraProvider value={theme}>
					<MobileProvider>
						<ErrorBoundary>
							<Routes>
								<Route path="/:identifier/:token" element={<Survey />} />
								<Route path="*" element={<NotFound isOnlyNotFoundText={true} />} />
							</Routes>
							<Toaster />
						</ErrorBoundary>
					</MobileProvider>
				</ChakraProvider>
			</QueryClientProvider>
		</BrowserRouter>
	</I18nextProvider>,
);
